import firebase from '@/plugins/firebase'
import Service from '@/services/abstract/service'

export default class Vendedor extends Service {
  constructor() {
    super()
    this._geoPoint = firebase.firestore.GeoPoint
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._veiculoRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Veiculos`
    )
    this._empresaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    )
    this._colaboradoresRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Colaboradores`
    )
  }

  async getLeadsAtrasadas(donoDoLead) {
    try {
      this._loading.setLoading(true, 'Carregando Leads Atrasadas')

      const response = await this._leadRef
        .where("donoDoLead", "==", donoDoLead)
        .where("dataProxContato", "<", new Date())
        .where("status", "==", "Pendente")
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsVenceAmanha(donoDoLead) {
    try {
      this._loading.setLoading(true, 'Carregando Leads que vencem amanhã')

      const dateStart = new Date()
      dateStart.setDate(dateStart.getDate() + 1)
      dateStart.setHours(0, 0, 0)

      const dateEnd = new Date()
      dateEnd.setDate(dateEnd.getDate() + 1)
      dateEnd.setHours(23, 59, 59)

      const response = await this._leadRef
        .where("donoDoLead", "==", donoDoLead)
        .where("dataProxContato", ">=", dateStart)
        .where("dataProxContato", "<=", dateEnd)
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsVenceHoje(donoDoLead) {
    try {
      this._loading.setLoading(true, 'Carregando Leads que vencem hoje')

      const dateStart = new Date()
      dateStart.setHours(0, 0, 0)

      const dateEnd = new Date()
      dateEnd.setHours(23, 59, 59)

      const response = await this._leadRef
        .where("donoDoLead", "==", donoDoLead)
        .where("dataProxContato", ">=", dateStart)
        .where("dataProxContato", "<=", dateEnd)
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByTemperatura(donoDoLead, temperatura) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const response = await this._leadRef
        .where('donoDoLead', '==', donoDoLead)
        .where('termometro', '==', temperatura)
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataCriacao(donoDoLead, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      const response = await this._leadRef
        .where('donoDoLead', '==', donoDoLead)
        .where('dataCriacao', '>=', dataInicio)
        .where('dataCriacao', '<=', dataFim)
        .orderBy('dataCriacao', 'desc')
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataProxContato(donoDoLead, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      const response = await this._leadRef
        .where('donoDoLead', '==', donoDoLead)
        .where('dataProxContato', '>=', dataInicio)
        .where('dataProxContato', '<=', dataFim)
        .orderBy('dataProxContato', 'desc')
        .get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoContato(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Historico')
      const response = await this._db
        .collection(`${this._prefix}-leads/${lead.id}/historicoContato`)
        .orderBy('dataContato', 'asc')
        .get()

      let historico = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          historico.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(historico)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoMovimentacao(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Historico')
      const response = await this._db
        .collection(`${this._prefix}-leads/${lead.id}/historicoMovimentacao`)
        .orderBy('dataMovimentacao', 'asc')
        .get()

      let historico = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          historico.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(historico)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getEmpresa(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Empresa da Lead')
      const response = await this._empresaRef
        .where('cnpj', '==', lead.empresa)
        .get()

      let empresa = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          empresa.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(empresa)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getColaborador(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Colaborador da Lead')
      const response = await this._colaboradoresRef
        .where('cpf', '==', lead.donoDoLead)
        .get()

      let colaborador = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          colaborador.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(colaborador)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getImagenVeiculo(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Veiculo')

      let veiculo = new Array()
      const response = await this._veiculoRef
        .where('descricao', '==', lead.nomeVeiculo)
        .get()
      if (!response.empty) {
        for (let doc of response.docs) {
          veiculo.push({
            id: doc.id,
            foto: doc.data().foto
          })
        }
      }

      return Promise.resolve(veiculo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  static separar(base, maximo) {
    let resultado = [[]]
    let grupo = 0

    for (let i = 0; i < base.length; i++) {
      resultado[grupo].push(base[i].nomeVeiculo)
      if (resultado[grupo].length === maximo) {
        grupo++
        resultado.push([])
      }
    }

    return resultado
  }

  static generateIdDoc(lead) {
    let id = lead.celular.replace(/\D/g, '')
    return id
  }

  async update(lead) {
    try {
      this._loading.setLoading(true, 'Carregando')
      const response = await this._leadRef.doc(lead.id)
      delete lead.id
      response.update(lead)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async create(lead) {
    try {
      this._loading.setLoading(true, 'Criando Lead')
      lead.location = new this._geoPoint(
        lead.location.latitude,
        lead.location.longitude
      )
      lead.dataProxContato = new Date(lead.dataProxContato)
      let id = Vendedor.generateIdDoc(lead)
      const response = await this._leadRef.doc(id).set(lead)
      lead.id = id
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
